import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLDivElement> {
  static targets = ['input', 'transferT1', 'actualDelivery']
  static values = {
    pldaEmergencyProcedure: Boolean
  }

  declare readonly inputTarget: HTMLInputElement
  declare readonly transferT1Targets: HTMLInputElement[]
  declare readonly actualDeliveryTargets: HTMLInputElement[]
  declare readonly pldaEmergencyProcedureValue: boolean

  form: HTMLFormElement | null = null

  #isAnyHiddenFieldBlank(fields: HTMLInputElement[] = []): boolean {
    return Array.from(fields).some(element => element.type === 'hidden' && element.value !== '')
  }

  #areAllFieldsBlank(fields: HTMLInputElement[]): boolean {
    return Array.from(fields).every(element => element.value === '')
  }

  #transferT1Validation(transferT1Value: string): string {
    let errors = ''
    const regexp = /^\w{18}$/
    if (transferT1Value.match(regexp) === null) {
      errors = 'Transfer T1 does not match criteria, (18 alphanumeric chars long)'
    }
    return errors
  }

  #submit(e: SubmitEvent): void {
    if (this.#isAnyHiddenFieldBlank(this.actualDeliveryTargets)) {
      let message = 'Are you sure you want to continue?'

      if (this.#areAllFieldsBlank(this.transferT1Targets))
        message += ' Transfer line number should be filled'

      message += ` ${this.#transferT1Validation(this.transferT1Targets[0].value)}`

      if (this.pldaEmergencyProcedureValue) {
        message += '\n\n\n⚠⚠⚠ PLDA Emergency Procedure is active ⚠⚠⚠'
      }

      const isConfirmed = confirm(message)

      if (!isConfirmed) e.preventDefault()
    }
  }

  connect(): void {
    this.form = this.inputTarget.form
    this.form?.addEventListener('submit', this.#submit.bind(this))
    this.inputTarget.remove()
  }

  disconnect(): void {
    this.form?.removeEventListener('submit', this.#submit.bind(this))
  }
}
